import { render, staticRenderFns } from "./page5.vue?vue&type=template&id=30ec9e7e&scoped=true"
import script from "./page5.vue?vue&type=script&lang=js"
export * from "./page5.vue?vue&type=script&lang=js"
import style0 from "./page5.vue?vue&type=style&index=0&id=30ec9e7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ec9e7e",
  null
  
)

export default component.exports